module.exports = __webpack_public_path__ + "static/media/advances-posting.77c41a23.svg";